var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('main-header'),_c('div',{staticStyle:{"width":"100%","display":"flex","justify-content":"center"}},[_c('img',{staticStyle:{"text-align":"center","margin-top":"100px","margin-bottom":"200px"},attrs:{"src":require('/src/assets/images/error400.jpg'),"alt":""}})]),_c('main-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }